import { makeStyles } from '@material-ui/core'

const CARD_HEIGHT = 164

export const useStyles = makeStyles((theme) => ({
  teamTitle: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(0),
  },
  teamParagraph: {
    marginBottom: theme.spacing(6),
  },
  teamMemberContainer: {
    display: 'grid',

    gridGap: theme.spacing(2),
    marginBottom: theme.spacing(15),
    gridTemplateColumns: 'repeat(1, 1fr)',
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
  },
  teamMemberCardLink: {
    textDecoration: 'none',
    color: 'inherit',
  },

  teamMemberCard: {
    height: CARD_HEIGHT,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.background.default,
  },
  memberImage: {
    height: CARD_HEIGHT,
  },
  teamContainer: {
    background: theme.palette.background.grey,
    width: '100vw',
    maxWidth: '100%',
    padding: theme.spacing(10),
  },

  teamMemberName: {
    fontWeight: '500',
  },

  teamMemberInfo: {
    padding: theme.spacing(4),
  },
}))
